export const BINDER_TENANT = {
  LIL_FIRES: 'cm1anc3fi000au75j8laqeady'
}

export const TENANT = {
  AAA_KK: 'cm9tpkapz0038zwcur7j96yqm',
  AALTO: 'cmoi6yaj100gxvrol8mttp5ke',
  AKI: 'cmttmt561000ufjdxx9ft1bdn',
  ALGOREN: 'cmr51njuo019vt1ppmq2q8g7t',
  ALPACA_INN: 'cmaxgmt3s001jk2sl4x4vnser',
  B_CURVE: 'cm5jkhtyf005red3jcyz7k67n',
  CF_FUDOSAN: 'cmh1x4npa0058ttglam00f0pm',
  CIM: 'cma9mg1wc005xan8r58h4ko01',
  DANDAN: 'cmct2gpri0046a27re1yx3d2h',
  DON_CUT: 'cmb2dk1ct00ox12wnpkpjosh5',
  FACE_FORWARD_HD: 'cm911ywi5002hiexxsjkmpwxp',
  FORTUNA: 'cmhro3ux3008fjthaf6tn8mc6',
  GOOD_SPACE: 'cme11cwwl003uhlkh90v3uzwr',
  HINAKO: 'cm9i7s8et003hsb00wuri82ez',
  HIRAKEMIRAI: 'cm9m9zovx001x7c8ftj7gx19u',
  HORIE: 'cm9glojle000zmn565ma6j16z',
  HYPAGE: 'cmi4a4g5d00hdhmrkoetdbmg4',
  IDEAL: 'cml4ysxdp00ib11va0wzddppl',
  KSTYLE: 'cm9nqo8au001l17t870pp4z8j',
  LINO: 'cmlohe8am03vyypjdvs473hqh',
  LIVMO: 'cmcwz0iw3001b495ul06kdg68',
  MARUNAGE: 'cm91ez5gm008aeav9bkkx5vip',
  MF_INVESTMENT: 'cmi5dnj4600dfrrd6znd72czm',
  MINPIKA_SHONAN: 'cmappfbsk0007jkmzf1ik5750',
  MIRAI_TERRACE: 'cm9f0bu100015qhtsc6gu67oq',
  MORI_MATSUMOTO: 'cma56vyiv0004qzyki6agx6co',
  MURAI_YUKA: 'cm9l5tutt00288wla7ci536uy',
  NEXT_CREATES: 'cmack5mye01224kliatcd0w7b',
  NIHON_AGENT: 'cmir66q3w01bw11ugjmxwvidv',
  ONECLEAN: 'cm6lvs25g00agh24bhcsbthtl',
  PIKA: 'cm5nmisl20001tgtjif3evdxt',
  PLAYS: 'cmou09amr00d1b9e8pnml79n9',
  RASHINBAN: 'cm8qz3q61000h6w3mn7gtby52',
  RECO_HOSPITALITY: 'cmqretu3i0esvxcilxcagos13',
  RESTA: 'cmfrsdaqe007n8lqdpt3nrkfs',
  REWARD: 'cmp5adadt01ffmmis17hhkjfc',
  RSUPPORT: 'cma3fzie1000bocxgbg1fcdc3',
  SAKURA_TRUST: 'cmo19gzfj00c9xvc3dzinrv2p',
  SAUNA: 'cm91jlewi008jeav9jlh5v5ms',
  SKYM_MINPA: 'cmfm563vk003guqp43oiwkx6f',
  SODATERU_TOUSHI: 'cmc7l72l2000x590ht3g9hdt3',
  TAGASHIRA: 'cm9kurqc00001mkkynhm9yxtf',
  TEST: 'cm6dpe4ks0001vedv2mzs5218',
  THEATER: 'cm9pv7q7q001ojntq0chf8q3n',
  TOKYO_INN: 'cm9841kyb0007zwjnpz8ae657',
  TORIPPA: 'cm6akdfed0002f61innti0kxk',
  YOKOE: 'cm9ayxuzt00c2coxpw0ix5mqk',
  YOKOYAMA_HOZEN: 'cmpdg1a0g010m4n4ut8jn5s9h',
  WATO: 'cmeqxwzwb00gax9rhpbz1fffb'
}
